import Box from '@mui/material/Box'
import React from 'react'
import {ErrorOutline} from '@mui/icons-material'

type GeneralErrorProps = {
    message?: string
}

const GeneralError = ({message = 'Error occurred'}: GeneralErrorProps) => {
    return (
        <Box
            paddingTop="5em"
            bgcolor="#edf6f9"
            width="100%"
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column">
            <ErrorOutline sx={{fontSize: 70}} color="error" />
            <h2>{message}</h2>
        </Box>
    )   
}

export default GeneralError